export const cookies = {
  ACCEPTED_COOKIES_POLICY: '_acceptedCookiesPolicy'
}

export function setCookie(name, value, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie =
    name + '=' + value + ';' + expires + ';path=/;SameSite=None;Secure';
}

export function getCookie(name) {
  const newName = name + '=';
  const ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(newName) === 0) {
      return c.substring(newName.length, c.length);
    }
  }
  return '';
}

export function checkCookie(name, value) {
  const user = getCookie(name);
  if (user !== '') {
    return true;
  } else {
    if (value !== '' && value !== null) {
      setCookie(name, value, 365);
      return false;
    }
  }
}
